<template lang="pug">
    .drawer-container
        el-button(
            type="info"
            icon="el-icon-fa-money-bill fas"
            size="large"
            @click="openCouponDrawer(null)"
        ) {{ $t('Create Coupon') }}
        coupon-form(
            width="580px"
            :data="drawer.form"
            :customer="drawer.customer"
            :visibility.sync="drawer.visibility"
            :submit-button-label="$t('Save and close')"
            @close="$emit('focus-search')"
            @closed="resetCouponDrawer"
            @submit="saveCoupon"
        )
            template(slot="footer-left" slot-scope="{ closeModal, submit }")
                el-button(
                    size="small"
                    icon="el-icon-fa-times fas"
                    @click="closeModal"
                ) {{ $t('Dismiss') }}
            template(slot="footer-right" slot-scope="{ closeModal, submit }")
                el-checkbox(
                    size="small"
                    border
                    :disabled="drawer.loading"
                    v-model="drawer.print"
                ) {{ $t('Print') }}
                el-button(
                    size="small"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    :loading="drawer.saving"
                    :disabled="drawer.loading"
                    @click="submit(false)"
                ) {{ $t('Save and close') }}
        //- el-drawer.coupon-drawer(
        //-     :title="drawer.title"
        //-     :visible.sync="drawer.visibility"
        //-     :modal="true"
        //-     size="50%"
        //-     @close="$emit('focus-search')"
        //-     @closed="resetCouponDrawer"
        //- )
        //-     //- v-loading="drawer.loading"
        //-     .drawer-body(
        //-         ref="couponDrawerBody"
        //-         v-dragscroll
        //-     )
        //-         el-form(
        //-             ref="form"
        //-             label-position="top"
        //-             :model="drawer.form"
        //-             :rules="drawer.rules"
        //-             @submit.prevent="submit"
        //-         )
        //-     .drawer-footer
        //-         el-button(
        //-             round
        //-             size="mini"
        //-             icon="el-icon-fa-times fas"
        //-             @click="closeCouponDrawer"
        //-         ) {{ $t('Dismiss') }}
        //-         el-button(
        //-             round
        //-             size="mini"
        //-             :disabled="drawer.loading || drawer.saving"
        //-             :loading="drawer.saving"
        //-             type="primary"
        //-             icon="el-icon-fa-check fas"
        //-         ) {{ $t('Save the coupon and close') }}
</template>

<i18n>
{
    "de": {
        "Create Coupon": "Gutschein erstellen",
        "Save the coupon and close": "Gutschein speichern und schließen",
        "Coupon could not be saved.": "Gutschein konnte nicht gespeichert werden.",
        "Coupon has been created successfully!": "Gutschein wurde erfolgreich erstellt!",
        "Could not print the coupon!": "Gutschein konnte nicht gedruckt werden!",
        "Print": "Drucken"
    }
}
</i18n>

<script>
import uniqid from 'uniqid'
import printJS from 'print-js-updated';
import { useSetupStore, usePosSetupStore, usePosCartStore } from '@/stores';

import CouponForm from '@/extensions/restrictedArea/views/Member/Form/Partials/CouponForm'
import CouponApi from '@/extensions/shop/pointOfSale/store/api/coupon'
import AuthApi from '@/store/api/system/auth';

export default {
    name: 'CouponDrawer',
    data() {
        return {
            drawer: {
                title: this.$t('Create Coupon'),
                visibility: false,
                loading: false,
                saving: false,
                print: true,
                customer: undefined,
                form: {},
                rules: undefined
            },
        };
    },
    components: {
        CouponForm,
    },
    computed: {
        activeCms() {
            return useSetupStore().activeCms
        },
        activeShop() {
            return this.activeCms.shop;
        },
        posSetupStore() {
            return usePosSetupStore();
        },
        posCartStore() {
            return usePosCartStore();
        },
        activePointOfSale() {
            return this.posSetupStore.activePointOfSale;
        },
        purchaser() {
            return this.posCartStore.purchaser;
        }
    },
    methods: {
        openCouponDrawer(amount) {
            this.drawer.customer = this.purchaser ? this.purchaser.customer : null
            if (! this.drawer.customer && this.activePointOfSale.customerGroup) {
                this.drawer.customer = {
                    id: null,
                    customerGroup: this.activePointOfSale.customerGroup
                }
            }
            this.drawer.form = {
                id: uniqid('new:'),
                name: undefined,
                description: undefined,
                code: uniqid(`POS-${this.activePointOfSale.id}-`).toUpperCase(),
                position: undefined,
                type: 'fixed',
                max_uses: 1,
                max_uses_per_customer: undefined,
                percentage: undefined,
                amount,
                start_at: undefined,
                end_at: undefined,
                // pivot: { uses: 0 },
                discard_the_following_coupons: false,
                discard_remaining_amount: false,
            }

            const customerGroup = _.get(this.drawer, 'customer.customerGroup')
            const defaultCustomerGroup = _.get(this.activeShop, 'defaultCustomerGroup');
            if (customerGroup && customerGroup.id !== defaultCustomerGroup.id) {
                this.drawer.form.applicable_for = 'customer-group'
                this.drawer.form.customerGroups = [ customerGroup ]
                this.drawer.form.currency = customerGroup.currency
            }

            this.drawer.visibility = true;

            this.$emit('blur-search');
            this.posSetupStore.updateAutofocusSearchInput(false);
        },
        async saveCoupon(data) {
            this.drawer.saving = true;
            const payload = {
                coupon: { ...data, shop: this.activeShop },
                pointOfSale: this.activePointOfSale,
                print: this.drawer.print,
            }
            const coupon = await CouponApi.create(payload)
                .catch(error => {
                    console.error(error)
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Coupon could not be saved.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                });

            if (coupon) {
                if (this.drawer.print && coupon.tillRoll) {
                    const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`, '/')
                    let table = 'files'

                    const file = coupon.tillRoll
                    const token = AuthApi.getToken()
                    const printable = `${storageRoute}/${table}/${file.id}/${file.name}?token=${token}`

                    printJS({
                        printable,
                        onLoadingEnd: () => {
                            // Don't close drawer here - wait for print dialog
                        },
                        onError: () => {
                            this.drawer.saving = false;
                            this.closeCouponDrawer();
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Could not print the coupon!'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000,
                            })
                        },
                        onPrintDialogClose: () => {
                            this.drawer.saving = false;
                            this.closeCouponDrawer();
                        }
                    })
                } else {
                    this.drawer.saving = false;
                    this.closeCouponDrawer();
                }

                this.$notify.success({
                    title: this.$t('Coupon has been created successfully!'),
                    iconClass: 'fas el-icon-fa-check',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000,
                })
            } else {
                this.drawer.saving = false;
            }
        },
        closeCouponDrawer() {
            this.drawer.visibility = false;
        },
        resetCouponDrawer() {
            this.drawer = {
                title: this.$t('Create Coupon'),
                visibility: false,
                loading: false,
                saving: false,
                print: true,
                customer: undefined,
                form: {},
                rules: undefined
            };

            this.posSetupStore.updateAutofocusSearchInput(true);
        }
    }
}
</script>

<style lang="sass" scoped>
.drawer-container
    .coupon-drawer
        .drawer-body
            flex-grow: 1
            overflow: auto
            padding: 0
            max-height: calc(100vh - 66px) // - 69px
::v-deep
    .modal-footer .right
        display: flex
        gap: 1rem
</style>
